var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 41.5,
    height: 29,
    rx: 3.5,
    fill: "white",
    stroke: "#B2BCCA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9737 21.0369C20.4937 22.2844 18.5738 23.0375 16.4759 23.0375C11.7948 23.0375 8 19.2879 8 14.6625C8 10.0372 11.7948 6.28754 16.4759 6.28754C18.5738 6.28754 20.4937 7.04066 21.9737 8.28821C23.4538 7.04066 25.3737 6.28754 27.4716 6.28754C32.1527 6.28754 35.9474 10.0372 35.9474 14.6625C35.9474 19.2879 32.1527 23.0375 27.4716 23.0375C25.3737 23.0375 23.4538 22.2844 21.9737 21.0369Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9736 21.0369C23.7961 19.5008 24.9517 17.215 24.9517 14.6625C24.9517 12.1101 23.7961 9.82428 21.9736 8.28815C23.4537 7.04064 25.3735 6.28754 27.4714 6.28754C32.1525 6.28754 35.9473 10.0372 35.9473 14.6625C35.9473 19.2879 32.1525 23.0375 27.4714 23.0375C25.3735 23.0375 23.4537 22.2844 21.9736 21.0369Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9736 21.0368C23.796 19.5007 24.9516 17.215 24.9516 14.6625C24.9516 12.1101 23.796 9.82435 21.9736 8.28822C20.1512 9.82435 18.9956 12.1101 18.9956 14.6625C18.9956 17.215 20.1512 19.5007 21.9736 21.0368Z",
    fill: "#FD6020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.ada73a2fbfae72b40698ba6b6674649a.svg";
export { ForwardRef as ReactComponent };